import { render, staticRenderFns } from "./FreeShippingNotification.vue?vue&type=template&id=3f06c647&"
import script from "./FreeShippingNotification.vue?vue&type=script&lang=js&"
export * from "./FreeShippingNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Notification: require('/~/src/components/Notification.vue').default})
